import { BannerType } from '@cox/core-ui8/dist/Banner'
import { ButtonStates, SimplifiedIcons } from '@cox/core-ui8/dist/Button'

import { DynamicBannerStatus } from '../../utils/types'
import { LinkTypes } from '../ReactImage'

export interface ReactBannerProps {
  bannerType: BannerType
  message?: string
  iconPath?: string
  altIcon?: string
  link?: string
  linkText?: string
  id?: string
  cqType?: string
  cqPath?: string
  isInEditor?: boolean
  variations?: BannerVariaion
  status?: DynamicBannerStatus
  buttonStates?: ButtonStates
  text?: string
  simplified?: SimplifiedIcons
  icon?: string
  tokenProperties?: string
  linkUrl?: string
  fileName?: string
  bannerId?: string
  linkId?: string
  linkType?: LinkTypes
  openInNewTab?: boolean
  anchor?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  chatText?: string
  isDismissable?: boolean
}

export enum BannerVariaion {
  DEFAULT = 'default',
  DEFAULT_BORDERED = 'default-bordered',
  INFO = 'info',
  PRIMARY = 'primary',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  LOGO = 'logo'
}

export type ReactAuthorableBannerProps = ReactBannerProps

export interface ReactPromoBannerProps extends ReactBannerProps {
  anchor?: string
  pageUrl?: string
  openInNewTab?: boolean
}

export interface ReactDynamicBannerProps extends ReactBannerProps {
  status?: DynamicBannerStatus
  message?: string
  link?: string
  linkText?: string
  newTab?: boolean
  isInEditor?: boolean
  fileName?: string
  variations?: BannerVariaion
}
